export const clerkConfig = {
  // Minimal configuration to prevent HTTP 431
  publishableKey: process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY,
};
